import DataMap from './DataMap';
import DataMapLegend from './DataMapLegend';

export default DataMap;
export {
  DataMapLegend
};



// WEBPACK FOOTER //
// ./src/components/Home/DataMap/index.js